import useSWR, { type SWRConfiguration } from 'swr';

import {
  getSuperlikesStatus,
  type GetSuperlikesStatusResponse,
} from '@services/SuperlikesService';

export type UseGetSuperlikesStatusParams = {
  isEnabled: boolean;
  swrOptions?: SWRConfiguration<GetSuperlikesStatusResponse, unknown>;
};

export const getSuperlikesStatusQueryKey = 'get-superlikes-status';

export const useGetSuperlikesStatus = ({
  isEnabled,
  swrOptions,
}: UseGetSuperlikesStatusParams) => {
  const { data, ...swrResponse } = useSWR<GetSuperlikesStatusResponse>(
    isEnabled ? getSuperlikesStatusQueryKey : null,
    () => getSuperlikesStatus(),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
